<template>
  <v-app app>
    <v-navigation-drawer fixed v-model="drawer" app>
      <v-list dense>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>contact_mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="indigo" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Risk</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="setView('positioninfo')" icon>
        <v-icon flip-horizontal>format_list_bulleted</v-icon>
      </v-btn>

      <v-btn @click="setView('resultreport')" icon>
        <v-icon >insert_chart_outlined</v-icon>
      </v-btn>

      <v-btn @click="setView('usersettings')" icon>
        <v-icon >settings</v-icon>
      </v-btn>

      <!-- <v-btn @click="setView('usersettings')" icon>
        <v-icon>save</v-icon>
      </v-btn> -->

    </v-toolbar>
    <v-content v-if="selectedView=='positioninfo'">
      <!-- 자가 , 임차 -->
      <!-- 자가 : 자가거주, 전세, 월세 -->
      <!-- 임차 : 전세, 월세 -->
      <PositionInfo
        ref="positionInfoComp"
        v-bind:userinfo="this.$store.state.userinfo"
        v-bind:portfolio_list="this.$store.state.portfolio_list"
      />
    </v-content>
    <v-content v-if="selectedView=='resultreport'">
      <ResultReport
        ref="resultReportComp"
        v-bind:results_data="this.$store.state.results_data"
        v-bind:userinfo="this.$store.state.userinfo"
        v-bind:position_list="this.$store.state.selected_portfolio.position_list"
      />
    </v-content>
    <v-content v-if="selectedView=='usersettings'">
      <UserSettings
        v-bind:results_data="this.$store.state.results_data"
        v-bind:userinfo="this.$store.state.userinfo"
        v-bind:position_list="this.$store.state.selected_portfolio.position_list"
      />
    </v-content>
    <!-- <v-footer color="indigo" app inset>
      <span class="white--text">&copy; 2017</span>
    </v-footer>-->
    <!-- <v-toolbar v-if="$store.state.isHeaderVisible">
      <v-toolbar-title class="headline text-uppercase">
        <span>Test</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat target="_blank" @click="setView('positions')">
        <span class="mr-2">Positions</span>
      </v-btn>
      <v-btn flat target="_blank" @click="setView('results')">
        <span class="mr-2">Report</span>
      </v-btn>
    </v-toolbar>-------->
  </v-app>
</template>

<script>
import PositionInfo from "./components/PositionInfo";
import ResultReport from "./components/ResultReport";
import UserSettings from "./components/UserSettings";
//import Login from "./components/Login";

export default {
  name: "App",
  components: {
    PositionInfo,
    ResultReport,
    UserSettings
    //Login
  },
  data() {
    return {
      drawer: false,
      mainstep: 0,
      selectedView: "positioninfo"
      //
    };
  },
  methods: {
    setView: function(viewName) {
      this.selectedView = viewName;

      if (viewName === "results") {
        // server call
      }
    },
    load_positions_from_key: function() {
      var this_component = this;

      var position_token = this.$store.getters.getCookie("position_token");

      console.log('load_positions_from_key : ' + position_token);

      this.$axios
        .post(this.$store.state.url_end_point + "/getpositions", {
          position_token: position_token
        })
        .then(function(response) {
          console.log(response.data);
          var message = response.data["message"];

          if (message == "success") {
            this_component.$store.state.userinfo = response.data["data"]["userinfo"];
            this_component.$store.state.selected_portfolio.position_list = response.data["data"]["position_list"];

            if (response.data["data"]["results_data"]) {
              this_component.$store.state.results_data = response.data["data"]["results_data"];
            }

            this_component.$store.state.isCalculated = false;

            // this_component.userinfo = response.data["data"]["userinfo"];
            // this_component.position_list =
            //   response.data["data"]["position_list"];
            // this_component.results_data = response.data["data"]["results_data"];
            // this_component.isCalculated = false;

            console.log(message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
   mounted: function() {
     if (this.$store.state.test == 'development')
     {
       this.$store.state.url_end_point = 'http://127.0.0.1:5000';
     }

     this.load_positions_from_key();
   }
  // computed: {
  //   mainstep: {
  //     get: function() {
  //       return this.$store.state.mainstep;
  //     },
  //     set: function(p) {
  //       this.$store.state.mainstep = p;
  //     }
  //   },
  // }
};
</script>

